export default __webpack_public_path__ + "static/media/three.5061214a.svg";